import { ValidationResult } from '@/types/setup';

export const validateApiKey = async (provider: 'openweathermap' | 'newsapi', apiKey: string): Promise<ValidationResult> => {
  if (!apiKey || apiKey.trim() === '') {
    return { isValid: false, error: 'API key is required' };
  }

  // Basic format validation
  switch (provider) {
    case 'openweathermap':
      // OpenWeatherMap API keys are typically 32 character alphanumeric strings
      if (apiKey.length !== 32 || !/^[a-zA-Z0-9]+$/.test(apiKey)) {
        return { 
          isValid: false, 
          error: 'OpenWeatherMap API key should be 32 alphanumeric characters' 
        };
      }
      break;
    
    case 'newsapi':
      // NewsAPI keys are typically 32 character alphanumeric strings
      if (apiKey.length !== 32 || !/^[a-zA-Z0-9]+$/.test(apiKey)) {
        return { 
          isValid: false, 
          error: 'NewsAPI key should be 32 alphanumeric characters' 
        };
      }
      break;
    
    default:
      return { isValid: false, error: 'Unknown provider' };
  }

  // Since we can't make direct API calls due to CORS, we'll do basic format validation
  // In a real app, this validation would be done on the backend
  try {
    // Simulate validation delay
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    // For demo purposes, consider keys valid if they pass format validation
    // In production, this would make actual API calls through a backend proxy
    return { isValid: true };
  } catch (error) {
    return { 
      isValid: false, 
      error: error instanceof Error ? error.message : 'Unknown error occurred' 
    };
  }
};